(function () {
  if (window.__daalsInpClickInit) return;
  window.__daalsInpClickInit = true;

  window.__daalsRunAfterPaint =
    window.__daalsRunAfterPaint ||
    function (fn) {
      setTimeout(fn, 0);
    };

  window.__daalsRunWhenIdle =
    window.__daalsRunWhenIdle ||
    function (fn) {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(fn, { timeout: 400 });
      } else {
        setTimeout(fn, 1);
      }
    };

  // Unlike __daalsRunAfterPaint (a plain macrotask, which the browser may still
  // run before its next rendering opportunity), this guarantees the callback
  // lands after the frame has been painted. Use it for work that invalidates
  // layout document-wide, so it cannot be charged to the interaction's INP.
  window.__daalsRunAfterNextPaint =
    window.__daalsRunAfterNextPaint ||
    function (fn) {
      requestAnimationFrame(function () {
        setTimeout(fn, 0);
      });
    };

  function resolvePdpSwatchRadio(target) {
    if (!target || !target.closest) return null;

    var label = target.closest('label.btooltip');
    if (label) {
      var section = label.closest('[id^="ProductSection-"]');
      if (!section || !label.closest('.swatch-element')) return null;
      var radio = label.htmlFor
        ? document.getElementById(label.htmlFor)
        : label.closest('.swatch-element').querySelector('.swatch-radio');
      return radio ? { radio: radio, label: label } : null;
    }

    if (target.classList && target.classList.contains('swatch-radio')) {
      if (!target.closest('[id^="ProductSection-"]')) return null;
      var linkedLabel = target.id
        ? document.querySelector('label[for="' + target.id.replace(/"/g, '\\"') + '"]')
        : null;
      return { radio: target, label: linkedLabel };
    }

    return null;
  }

  function syncSwatchSelection(radio) {
    if (!radio) return;
    var scope = radio.closest('.selector-wrapper') || radio.closest('.swatch');
    if (scope) {
      scope.querySelectorAll('.swatch-radio.selected').forEach(function (el) {
        el.classList.remove('selected');
      });
    }
    radio.checked = true;
    radio.classList.add('selected');
    var valueLabel = scope && scope.querySelector('.option-select-value');
    if (valueLabel && radio.value) valueLabel.textContent = radio.value;
  }

  function handleShopLookClick(target, e) {
    if (typeof window.__openShopLookPanel !== 'function') return false;

    if (
      target.closest('#shopBtn, .shop-the-look-trigger') ||
      target.closest('.productDrop .lg-hotspot')
    ) {
      e.preventDefault();
      // e.stopImmediatePropagation();
      window.__openShopLookPanel();
      return true;
    }

    if (target.closest('#close-panel') || target.classList.contains('shop-window-bg')) {
      e.preventDefault();
      // e.stopImmediatePropagation();
      if (typeof window.__closeShopLookPanel === 'function') {
        window.__closeShopLookPanel();
      }
      return true;
    }

    return false;
  }

  // Same class toggles theme.js does for `.cart-block-click`, without going
  // through jQuery. Opens only; never toggles closed.
  function openCartDrawer() {
    var cartBg =
      document.querySelector('#cart_info .cart-window-bg') ||
      document.querySelector('.cart-window-bg');
    var cartNosto =
      document.querySelector('#cart_info .cart-nosto-window') ||
      document.querySelector('.cart-nosto-window');

    if (cartBg && cartBg.classList.contains('window-hide')) {
      window.savedScrollPosition = window.scrollY;
      cartBg.classList.remove('window-hide');
      if (cartNosto) cartNosto.classList.remove('window-hide');
      document.documentElement.classList.add('cart-open');
      document.body.classList.add('cart-open');
    }
  }

  // Shared by the main ATC button and the sticky footer button: show the
  // drawer skeleton in this frame, do the form serialisation + XHR only after
  // that frame has painted so none of it is charged to the click's INP.
  function startAddToCart(btn) {
    var cartSidebar = document.getElementById('cart-sidebar');

    openCartDrawer();

    if (window.roar && typeof window.roar.openCartSidebarWithSkeleton === 'function') {
      window.roar.openCartSidebarWithSkeleton();
    } else if (cartSidebar) {
      var hasCartItems =
        !!document.querySelector('#cart-sidebar .cart-window-body .cart-item') ||
        !!document.querySelector('#cart-sidebar .cart-total');
      cartSidebar.classList.remove('is-loading', 'is-loading-empty', 'is-loading-add');
      cartSidebar.classList.add(hasCartItems ? 'is-loading-add' : 'is-loading-empty');
    }

    btn.classList.add('is-atc-loading');
    btn.setAttribute('aria-busy', 'true');

    window.__daalsRunAfterNextPaint(function () {
      if (window.roar && typeof window.roar.processAddToCartButton === 'function') {
        window.roar.processAddToCartButton(btn);
      }
    });
  }

  function handleAddToCartClick(target, e) {
    if (window.shopping_cart_type !== 'sidebar') return false;

    var btn = target.closest('[id^="AddToCart-"].add-to-cart');
    if (!btn || btn.disabled || btn.classList.contains('disabled')) return false;

    e.preventDefault();
    // e.stopImmediatePropagation();

    startAddToCart(btn);
    return true;
  }

  // Sticky footer "add to basket". Replaces the jQuery path in theme.js
  // (_initStickyInfo) which did `$(addToCart).trigger('click')` – a synthetic
  // event that walks every jQuery handler up to document before the native
  // click even fires – and the capture listener that used to live in
  // snippets/cart-panel.liquid for the "already in basket" state.
  function handleStickyAtcClick(target, e) {
    if (window.shopping_cart_type !== 'sidebar') return false;

    var stickyBtn = target.closest('.sticky-button.button-cart');
    if (!stickyBtn) return false;

    e.preventDefault();

    // cart-panel.js keeps this class in sync with the drawer contents.
    if (stickyBtn.classList.contains('el-prod_added-state')) {
      openCartDrawer();
      return true;
    }

    var wrap = stickyBtn.closest('.sticky-info-product');
    var sectionId = wrap && wrap.id ? wrap.id.replace(/^sticky-info-/, '') : '';
    var atcBtn =
      (sectionId && document.getElementById('AddToCart-' + sectionId)) ||
      document.querySelector('[id^="AddToCart-"].add-to-cart');

    if (!atcBtn || atcBtn.disabled || atcBtn.classList.contains('disabled')) return true;

    startAddToCart(atcBtn);
    return true;
  }

  function handleAccordionClick(target, e) {
    var heading = target.closest('.product-accordions .tab-heading');
    if (!heading) return false;

    var accordion = heading.closest('.product-accordion');
    var root = heading.closest('.product-accordions');
    if (!accordion || !root) return false;

    e.preventDefault();
    // No stopPropagation: GTM listens on document for component-tracking-id clicks.

    var willOpen = !accordion.classList.contains('active');

    // Frame 1 (charged to INP): only the tapped heading changes. The chevron
    // and bold state key off aria-expanded in CSS, so this is one small style
    // recalc and no layout of the panel.
    heading.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

    // Frame 2: the actual display toggle. rAF -> setTimeout guarantees this
    // runs after frame 1 has painted, so the panel layout (display:none ->
    // block of the description subtree + relayout of everything below it) is
    // not charged to the tap.
    window.__daalsRunAfterNextPaint(function () {
      root.querySelectorAll('.product-accordion.active').forEach(function (item) {
        item.classList.remove('active');
        var h = item.querySelector('.tab-heading');
        if (h && item !== accordion) h.setAttribute('aria-expanded', 'false');
      });
      if (willOpen) accordion.classList.add('active');
    });

    return true;
  }

  // Seed aria-expanded so the CSS feedback state matches the server-rendered
  // .active state before the first tap.
  function initAccordionState() {
    document.querySelectorAll('.product-accordions .product-accordion').forEach(function (item) {
      var h = item.querySelector('.tab-heading');
      if (h) h.setAttribute('aria-expanded', item.classList.contains('active') ? 'true' : 'false');
    });
  }

  function handleSwatchClick(target, e) {
    if (!target.closest('.swatch-element') && !target.classList.contains('swatch-radio')) {
      return false;
    }

    var ctx = resolvePdpSwatchRadio(target);
    if (!ctx || !ctx.radio || ctx.radio.disabled) return false;
    if (ctx.radio.classList.contains('selected') && ctx.radio.checked) return false;

    e.preventDefault();
    // e.stopPropagation();
    // e.stopImmediatePropagation();

    syncSwatchSelection(ctx.radio);

    var swatchType = (ctx.radio.getAttribute('data-swatch') || '').toLowerCase();
    if (
      typeof window.__daalsSyncMattressRelatedSize === 'function' &&
      (swatchType.indexOf('size') !== -1 ||
        swatchType.indexOf('model') !== -1 ||
        swatchType.indexOf('style') !== -1) &&
      ctx.radio.value
    ) {
      window.__daalsRunWhenIdle(function () {
        window.__daalsSyncMattressRelatedSize(ctx.radio.value);
      });
    }

    window.__daalsRunAfterPaint(function () {
      if (window.jQuery) {
        ctx.radio.__daalsFromCapture = true;
        window.jQuery(ctx.radio).trigger('click');
      }
    });

    window.__daalsRunWhenIdle(function () {
      if (typeof window.__daalsApplySwatchStockUI === 'function' && ctx.label) {
        window.__daalsApplySwatchStockUI(ctx.label.textContent);
      }
    });

    return true;
  }

  var inpTargetSelector =
    '#shopBtn, .shop-the-look-trigger, .productDrop, #close-panel, .shop-window-bg, ' +
    '[id^="AddToCart-"], .sticky-button.button-cart, .slick-arrow, .thumbnails-item, .product-accordions, ' +
    '.swatch-element, .swatch-radio';

  document.addEventListener(
    'click',
    function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      if (!target.closest(inpTargetSelector)) return;

      if (handleShopLookClick(target, e)) return;
      if (handleAddToCartClick(target, e)) return;
      if (handleStickyAtcClick(target, e)) return;

      var galleryApi = window.__daalsInpGalleryApi;
      if (galleryApi) {
        if (galleryApi.handleArrowClick(target, e)) return;
        if (galleryApi.handleThumbClick(target, e)) return;
      }

      if (handleAccordionClick(target, e)) return;
      handleSwatchClick(target, e);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordionState);
  } else {
    initAccordionState();
  }

  window.__daalsInpSwatchInit = true;
  window.__daalsInpAtcInit = true;
  window.__daalsInpStickyInit = true;
  window.__daalsInpGalleryNavInit = true;
  window.__daalsInpAccordionInit = true;
})();
